import { apiGet } from '../client';

export const fetchBootstrapData = options => apiGet('bootstrap', undefined, options);
